import { render, staticRenderFns } from "./userProfileList.vue?vue&type=template&id=63e500f4"
import script from "./userProfileList.vue?vue&type=script&lang=js"
export * from "./userProfileList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports